import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api';
import { usePanelStore } from '@/features/panel/store/panel-store';

const ME_KEY = ['me'] as const;

function isUnauthenticated(error: unknown): boolean {
  return error instanceof ApiError && error.status === 401;
}

/**
 * Tratamento global de 401 (#65): quando QUALQUER query/mutation falha com 401
 * — ex.: logout em outra aba zera o cookie `__Host-mm_session` e o poll de
 * `useActiveLives` (a cada 30s) passa a responder 401 — zeramos o cache de `me`
 * e o estado de sessão do painel. `useMe` volta a `null`, então RequireAuth /
 * PanelPage redirecionam pra /auth/connect sem precisar de refresh manual.
 *
 * Idempotente: se `me` já está `null`, retorna cedo — várias queries 401 em
 * sequência convergem pro mesmo estado sem re-render extra.
 */
function handleUnauthenticated(): void {
  if (queryClient.getQueryData(ME_KEY) === null) return;
  queryClient.setQueryData(ME_KEY, null);
  usePanelStore.getState().clearPanelSession();
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (isUnauthenticated(error)) handleUnauthenticated();
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isUnauthenticated(error)) handleUnauthenticated();
    },
  }),
  defaultOptions: {
    queries: { retry: false, staleTime: 60_000 },
  },
});
